export default "__VITE_ASSET__BoUCZgNk__"